module.exports = __webpack_public_path__ + "img/baas_40.2fe341e8.png";